<template>
  <transition name="fade">
    <div v-if="internalValue" id="applicant-edit-tab-job">
      <VacancyStat
        v-if="
          internalValue.number && $store.getters['user/hasPermission']('bi')
        "
        :number="internalValue.number"
      ></VacancyStat>

      <div class="job-edit-menu p-3">
        <ul>
          <li>
            <a
              v-smooth-scroll="{ offset: -50 }"
              href="#jobAllgemein"
              class="lg:text-xl font-medium text-gray-600"
              >Allgemein</a
            >
          </li>
          <li>
            <a
              v-smooth-scroll="{ offset: -50 }"
              href="#website"
              class="lg:text-xl font-medium text-gray-600"
              >Webseite</a
            >
          </li>
          <li>
            <a
              v-smooth-scroll="{ offset: -50 }"
              href="#jobEinstellungen"
              class="lg:text-xl font-medium text-gray-600"
              >Stellen Einstellungen</a
            >
          </li>
          <li>
            <a
              v-smooth-scroll="{ offset: -50 }"
              href="#jobBeschreibung"
              class="lg:text-xl font-medium text-gray-600"
              >Stellen Beschreibung</a
            >
          </li>
          <li>
            <a
              v-smooth-scroll="{ offset: -50 }"
              href="#applicant-table"
              class="lg:text-xl font-medium text-gray-600"
              >Bewerber</a
            >
          </li>
          <li v-if="$store.getters['user/hasPermission']('bi')">
            <a
              v-smooth-scroll="{ offset: -50 }"
              href="#qrcode"
              class="lg:text-xl font-medium text-gray-600"
              >Qr-Code</a
            >
          </li>
        </ul>
      </div>
      <ValidationObserver ref="jobEdit" tag="form">
        <JobGeneralForm
          v-model="internalValue"
          :project-consultant-i-d="projectConsultantID"
        />
      </ValidationObserver>
      <!-- additionalServices -->
      <vs-button @click="saveData()">Speichern</vs-button>
      <div id="applicant-table">
        <job-applicant-table :vacancy-i-d="vacancy.id" />
      </div>
      <div v-if="vacancy && $store.getters['user/hasPermission']('bi')">
        <QrCodes :vacancy="vacancy" />
      </div>
    </div>
  </transition>
</template>

<script>
import gql from "graphql-tag";
import jobVariants from "@/data/enums/JobVariant.js";
import editFormMixin from "@/mixins/editFormMixin.js";
import JobGeneralForm from "../form/JobGeneral";
import VacancyStat from "../stats/VacancyStat";
import JobApplicantTable from "../../../components/job/JobApplicantTable.vue";
import QrCodes from "@/components/job/JobQrCodes";

export default {
  components: {
    VacancyStat,
    JobGeneralForm,
    JobApplicantTable,
    QrCodes
  },
  mixins: [
    editFormMixin({
      idFields: ["vamOccupation", "vamExportError", "occupationBenefit"],
      legacyIDFields: ["jobTimes"],
      ignoredFields: ["number"]
    })
  ],
  props: {
    projectId: { type: String, required: true },
    projectConsultantID: { type: String, required: false }
  },
  data() {
    return {
      jobVariants,
      fetchFailed: false,
      currentPage: 0,
      accordionOpen: [],
      createData: null
    };
  },
  apollo: {
    vacancy: {
      query: gql`
        query Vacancy($id: ID!) {
          vacancy(id: $id) {
            id
            number
            title
            companyProfileText
            activeFrom
            activeUntil
            workPlace
            project {
              id
              userGroup {
                id
              }
            }
            jobType {
              id
              name
            }
            active
            internalInfo
            recruitment
            allowOnlineApplication
            companyLogoID
            occupationCategory {
              id
              name
            }
            occupationBenefit {
              id
              name
            }
            jobActivitiesText
            jobProfilesText
            jobPerspectiveText
            jobInfosText
            jobCustomerDetailsText
            jobFooterText
            topjob
            topjobDate
            holidayAndChristmasBonus
            additionalServices
            jobEarningLegacy
            takeoverOption
            jobHoursLegacy
            vamExport
            vamTitle
            vamOccupation {
              id
              name
            }
            vamJobOfferType
            vamEducationAuthorization
            vamSocialInsurance
            vamExportError
            publication {
              id
              rePublishFrom
              rePublishUntil
              rePublishAmount
              rePublishInterval
            }
            address {
              street
              country
              zip
              city
              lat
              lng
            }
            jobTimes {
              id
              name
            }
            jobVariant
            jobTemplateID
            contactType
            contactID
            contactEmail
          }
        }
      `,
      skip() {
        return (
          !this.$route.params.jobid || this.$route.params.jobid === "create"
        );
      },
      result() {
        this.updateCurrent();
      },
      variables() {
        return {
          id: this.$route.params.jobid
        };
      },
      fetchPolicy: "network-only"
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.createData ? this.createData : this.vacancy;
      },
      set(v) {
        if (this.$route.params.jobid === "create") {
          this.createData = v;
        } else {
          this.save(false);
        }
      }
    }
  },
  watch: {
    "$route.params.jobid": {
      immediate: true,
      handler(v) {
        if (v === "create") {
          this.createData = {
            vamSocialInsurance: true
          };
        } else {
          this.createData = null;
        }
      }
    },
    internalValue: {
      deep: true,
      handler: function(v) {
        this.internalValue = v;
      }
    }
  },
  methods: {
    async saveData() {
      if (this.$route.params.jobid === "create") {
        return await this.persist();
      }

      return await this.save();
    },
    async persist() {
      if (this.$route.params.jobid === "create") {
        await this.$apollo
          .mutate({
            mutation: gql`
              mutation($input: CreateVacancyInput!, $project: ID!) {
                vacancyCreate(projectId: $project, input: $input) {
                  id
                }
              }
            `,
            variables: {
              input: Object.prepareGqlInput(this.createData),
              project: this.projectId
            }
          })
          .then(({ data }) => {
            const jobid = data.vacancyCreate.id;

            if (!jobid) {
              // TODO: Handle error
              return;
            }

            this.$router.push({
              name: "project.edit.sub.job",
              params: { page: "jobs", jobid }
            });
          });
      } else {
        let result = await this.$refs.jobEdit.validate();
        if (result) {
          let input = this.getInput();
          delete input.project;
          if (input.publication) {
            input.publication = Object.prepareGqlInput(
              input.publication,
              [],
              ["rePublishFrom"]
            );
          }

          if (input.jobType && typeof input.jobType == "object") {
            input.jobType = input.jobType.id;
          }
          console.log(input.occupationCategory);
          if (
            input.occupationCategory &&
            typeof input.occupationCategory == "object"
          ) {
            input.occupationCategory = input.occupationCategory.id;
          }
          console.log(input.occupationCategory);
          try {
            await this.$apollo.mutate({
              mutation: gql`
                mutation($id: ID!, $input: VacancyInput!) {
                  vacancyUpdate(id: $id, input: $input) {
                    id
                  }
                }
              `,
              variables: {
                id: this.internalValue.id || this.$route.params.jobid,
                input
              }
            });

            this.reportSuccess(input);
          } catch (e) {
            this.reportUnhandledError(e);
          }
        } else {
          this.$vs.notify({
            title: "Fehlgeschlagen",
            text: "Eingabe ist fehlgeschlagen.",
            color: "danger",
            icon: "query_builder",
            position: "bottom-center"
          });
          //document.documentElement.scrollTop = 0;
        }
      }
    }
  }
};
</script>
